import React, {Component} from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import StyledProgressbar from "../../Containers/Graph/StyledProgressbar";

import * as HomeworkService from '../../../services/Student/HomeworkService';
import PopupAlert from "../../Containers/PopupAlert";
import Moment from "moment";

const initState = {
	visible: false,
        user: null,
        dailyTestInputBox: false,
        startDate: null,
        endDate: null,
        dailyTestDate: new Date(),
        result: [
            {id: 0, name:"Vocabulary", subject:"vocabulary", className: "btn-mini", filterGraphEnable: true, filterScoreByDateEnable: true, result: [], percentage: 0, average: 0 },
            {id: 1, name:"Reading", subject:"reading", className: "btn-mini read", filterGraphEnable: true, filterScoreByDateEnable: true, result: [], percentage: 0, average: 0 },
            {id: 2, name:"Listening", subject:"listening", className: "btn-mini listen", filterGraphEnable: true, filterScoreByDateEnable: true, result: [], percentage: 0, average: 0 },
            {id: 3, name:"Speaking", subject:"speaking", className: "btn-mini speak", filterGraphEnable: true, filterScoreByDateEnable: true, result: [], percentage: 0, average: 0 },
            {id: 4, name:"Daily Test", subject:"dailytest", className: "btn-mini daily", filterGraphEnable: true, filterScoreByDateEnable: true, result: [], percentage: 0, average: 0 },
        ],
        groupOption: {name: "전체", subject:"전체", className: "btn-mini", filterGraphEnable: true, filterScoreByDateEnable: true},
        resultEmpty: true,
        overallRating: [
            { id: 0, name: "Poor", min: 0, max: 50 },
            { id: 1, name: "Average", min: 50, max: 60 },
            { id: 2, name: "Good", min: 60, max: 70 },
            { id: 3, name: "Very Good", min: 70, max: 80 },
            { id: 4, name: "Excellent", min: 80, max: 90 },
            { id: 5, name: "Outstaning", min: 90, max: 100 },
        ],
        errorMessage: ""
}
class PopupReportCard extends Component {
    state = initState;

    componentWillReceiveProps = (nextProps) => {
	if (this.state.visible != nextProps.active) {
	    this.setState({
	            visible: nextProps.active,
	            user: nextProps.user,
	            resultEmpty: true,
	            startDate: new Date(),
	            endDate: new Date(),
	            dailyTestDate: new Date(),
	            result: [
	                {id: 0, name:"Vocabulary", subject:"vocabulary", className: "btn-mini", filterGraphEnable: true, filterScoreByDateEnable: true, result: [], percentage: 0, average: 0 },
	                {id: 1, name:"Reading", subject:"reading", className: "btn-mini read", filterGraphEnable: true, filterScoreByDateEnable: true, result: [], percentage: 0, average: 0 },
	                {id: 2, name:"Listening", subject:"listening", className: "btn-mini listen", filterGraphEnable: true, filterScoreByDateEnable: true, result: [], percentage: 0, average: 0 },
	                {id: 3, name:"Speaking", subject:"speaking", className: "btn-mini speak", filterGraphEnable: true, filterScoreByDateEnable: true, result: [], percentage: 0, average: 0 },
	                {id: 4, name:"Daily Test", subject:"dailytest", className: "btn-mini daily", filterGraphEnable: true, filterScoreByDateEnable: true, result: [], percentage: 0, average: 0 },
	            ],
	            groupOption: {name: "전체", subject:"전체", className: "btn-mini", filterGraphEnable: true, filterScoreByDateEnable: true},
	            errorMessage: ""
	        });
	    console.log(nextProps.user.username);
	    this.searchReport(new Date(), new Date(), nextProps.user.username);
	}
    }

    closePopup = () => {
        this.props.onClose();
    }

    handleChangeStart = (date) => {
			if (date > this.state.endDate) {
					this.setState({startDate : date, endDate : null});
			} else {
					this.setState({startDate : date});
			}
    }

		handleChangeEnd = (date) => {
			if (date < this.state.startDate) {
					this.setState({startDate : null, endDate : date});
			} else {
					this.setState({endDate : date});
			}
    }

    searchReport = (startDate, endDate, username) => {
    	//const { startDate, endDate, user } = this.state;
			console.log(endDate);
    	if (startDate == null) {
				this.setState({ errorMessage: "start date 설정 오류" });
				return;
    	} else if (endDate == null) {
    		this.setState({ errorMessage: "end date 설정 오류" });
	    	return;
    	}
    	const _startDate = Moment(startDate).format('YYYY-MM-DD');
    	const _endDate = Moment(endDate).format('YYYY-MM-DD');
			HomeworkService.getReports(username, _startDate, _endDate).then((response) => {
				if( response.status === 200 ) {
					const { result } = this.state;
					let changeResult = result;
					console.log(response.data.data);
					const responseData = response.data.data;
					let resultVO = {
						vocabulary: [],
						reading: [],
						listening: [],
						speaking: [],
						dailytest: []
					};

					for (var i in responseData) {
							const peekIndex = this.findIndex(resultVO[responseData[i].subject], responseData[i].completedExamDate);
							const subject = responseData[i].subject;
							if (peekIndex == -1) {
						const length = resultVO[subject].length;
						resultVO[subject][length] = Object.assign({}, responseData[i]);
						resultVO[subject][length].count = 1;
							}
							else {
						resultVO[subject][peekIndex].percentage += responseData[i].percentage;
						resultVO[subject][peekIndex].count += 1;
							}
					}

					for (let i=0; i<changeResult.length; i++) {
							const subject = changeResult[i].subject;
							changeResult[i].result = Object.assign([], resultVO[subject]);

							for (let j=0; j<changeResult[i].result.length; j++) {
						const percentage = changeResult[i].result[j].percentage / changeResult[i].result[j].count;
						changeResult[i].result[j].percentage = percentage;
							}
					}
					this.setState({ result : changeResult, resultEmpty : responseData.length == 0 });
				} else {
					alert('getReports FAILED');
				}
			}).catch( (error) => {
				console.log(error);
				alert('SERVER ERROR');
			});
    }
    getTotalScore = (list) => {
			let score = 0;
			list.forEach((item, i) => {
				 score += item.percentage;
			});
			return score;
    }

    showDailyBox = () => {
			this.setState({dailyTestInputBox: !this.state.dailyTestInputBox});
    }
    showDailyTestInputBox = () => {
	if(this.state.dailyTestInputBox) {
	    return (
				<div className="wrap-write selected">
					<div className="wrap-date">
						<DatePicker
												selected={this.state.dailyTestDate}
												selectsStart
												onChange={this.onChangeDailyTestDate}/>
										</div>
										<span>DailyTest</span>
										<div className="box-grade">
												<input type="text" defaultValue={this.inputValue} placeholder="0" onChange={this.onChangeInputValue}/>
												<span>점</span>
										</div>
										<a className="btn-mini" onClick={this.sendDailyTestResult}>확인</a>
						</div>
					);
			}
    }

    onChangeDailyTestDate = (date) => {
			this.setState({ dailyTestDate : date });
    }

    onChangeInputValue = (e) => {
			this.inputValue = e.target.value;
    }

    sendDailyTestResult = () => {
	const { startDate, endDate, user } = this.state;
	console.log(endDate);
	this.showDailyBox();

	if (this.inputValue != undefined) {
	   let reportDto = {
		   correctNum: this.inputValue * 1,
		   totalExamNum: 100
	   };
	   console.log(reportDto);
	   HomeworkService.insertCustomReport(user.username, reportDto).then((response)=> {
	       if( response.status === 200 ) {
		   console.log(response);
		   this.searchReport(startDate, endDate, user.username);
		   // 전체 score 합계, 평균 필요 -> 종합평가도 요걸로
		   // 영역별 score 평균
	       } else {
		   alert('insert CustomReport FAILED');
	       }
	   }).catch( (error) => {
	       console.log(error);
	       alert('SERVER ERROR');
	   });
	} else {
	    this.setState({ errorMessage : "Daily 시험 점수를 입력해주세요." });
	}
    }

    showSectionFilterButton = (type) => {
	if (this.state.resultEmpty)
	    return;

	const itemList = this.state.result.map(
	                ({id, className, name, filterGraphEnable, filterScoreByDateEnable, result}) => (
	                	<a key={id}
	                	className={((type === "graph" && !filterGraphEnable) || (type !== "graph" && !filterScoreByDateEnable))? "btn-mini dim" : className}
	                	onClick={()=> {this.onChangeSectionFilterValue(type, id)}}>{name}</a>
	                )
	            )

	return itemList;//(<div className="box-filter"> {itemList} </div>);
    }

    onChangeSectionFilterValue = (type, id) => {
	const { result, groupOption } = this.state;

	if (id == -1) {
	    if (type === "graph") {
		groupOption.filterGraphEnable = !groupOption.filterGraphEnable;
		result.forEach((item, i) => {
		   item.filterGraphEnable = groupOption.filterGraphEnable;
		});
	    } else {
		groupOption.filterScoreByDateEnable = !groupOption.filterScoreByDateEnable;
		result.forEach((item, i) => {
		    item.filterScoreByDateEnable = groupOption.filterScoreByDateEnable;
		});
	    }
	} else {
	    if (type === "graph") {
		result[id].filterGraphEnable = !result[id].filterGraphEnable;
	    } else {
		result[id].filterScoreByDateEnable = !result[id].filterScoreByDateEnable;console.log(result[id].filterScoreByDateEnable);
	    }
	}

	this.setState({ result : result, groupOption : groupOption });
    }

    showSectionScore = () => {
	const { result, resultEmpty } = this.state;
	if (!resultEmpty) {
	    const resultVO = this.getTotalSectionScore();
	    return (
		    <div className="box-each">
		        <h2>Section 영역별 점수</h2>
		        <div className="box-in">
		        	<div className="wrap-chart">
		        	{
		        	    result.map(({ id, name, subject, filterGraphEnable, percentage, result }) => (
					(result != null && result.length > 0 && filterGraphEnable) &&
					<div key={id} className={"box-chart ".concat(subject)}>
			                    <StyledProgressbar subject={name} percentage={percentage}/>
			                </div>)
		        	)}
		        	</div>
		        	<ul className="list-score">
		        		<li className="txt-total">{resultVO.score}</li>
        		                <li className="txt-score">{Math.round(resultVO.average)}</li>
    		                </ul>
		        </div>
		    </div>
	    );
	}
    }

    // filter 기능 추가하게 되면 score 더하기 여부 체크 들어가야함
    getTotalSectionScore = () => {
	const { result } = this.state;
	let resultVO = {
		score: 0,
		average: 0
	}

	let score = 0;
	let length = 0;
	for (let i=0; i<result.length; i++) {
	    if (result[i].filterGraphEnable && result[i].result != null) {
		for(let j=0; j<result[i].result.length; j++) {
		    score += result[i].result[j].percentage * result[i].result[j].count;
		    length += result[i].result[j].count;
		}
	    }
	}
	resultVO.score = score;
	resultVO.average = (length == 0)? 0 : score / length;
	return resultVO;
    }



    findIndex = (result, doneDate) => {
	let index = -1;
	result.forEach((item, i) => {
	    if (Moment(item.completedExamDate).format('YYYY-MM-DD') == Moment(doneDate).format('YYYY-MM-DD')) {
		index = i;
		return index;
	    }
	});
	return index;
    }

    showAverageByDate = () => {
	const { resultEmpty, result } = this.state;
	let averageList = [];
	for (let i=0; i<result.length; i++) {
	    if (result[i].filterScoreByDateEnable){
		for (let j=0; j<result[i].result.length; j++) {
		    // averageList에 저장된 데이터들의 doneDate를 체크,
		    // 이미 저장된 데이터가 있으면 해당 데이터에 percentage만 +
		    const index = this.findIndex(averageList, result[i].result[j].completedExamDate);
		    if (index == -1) {
			var length = averageList.length;
			averageList[length] = Object.assign({}, result[i].result[j]);
			averageList[length].percentage = result[i].result[j].percentage * result[i].result[j].count;
		    } else {
			averageList[index].percentage += result[i].result[j].percentage * result[i].result[j].count;
			averageList[index].count += result[i].result[j].count;
		    }
		}
	    }
	}

	for(let i=0; i<averageList.length; i++) {
	    averageList[i].percentage = averageList[i].percentage / averageList[i].count;
	}

	const column = this.getColumnData(averageList);
	return (
		(!resultEmpty && averageList.length > 0) &&
	<div className="box-each">
                <h2>Average</h2>
                <div className="box-in type-test">
                    <table className="tb-test">
                        <colgroup>
                            <col width="14.28%"/>
                            <col width="14.28%"/>
                            <col width="14.28%"/>
                            <col width="14.28%"/>
                            <col width="14.28%"/>
                            <col width="14.28%"/>
                            <col width="14.28%"/>
                        </colgroup>
                        <tbody>
                        {column}
                        </tbody>
                    </table>
                </div>
            </div>
	);
    }

    showScoreByDate = (subject, className) => {
	const { result } = this.state;
	let index = -1;
	result.forEach((item, i) => {
	    if (item.subject === subject)
		index = i;
	});
	const peekData = result[index];
	if (peekData.result.length == 0 || !peekData.filterScoreByDateEnable)
	    return;

	const column = this.getColumnData(peekData.result);
	return (
		<div className="box-each">
                 <h2>{peekData.name}</h2>
                 <div className={className}>
                     <table className="tb-test">
                         <colgroup>
                             <col width="14.28%"/>
                             <col width="14.28%"/>
                             <col width="14.28%"/>
                             <col width="14.28%"/>
                             <col width="14.28%"/>
                             <col width="14.28%"/>
                             <col width="14.28%"/>
                         </colgroup>
                         <tbody>
                        {column}
                         </tbody>
                     </table>
                 </div>
             </div>
	);
    }

    getColumnData = (list) => {
	const mapList = [];
	const leaving = (7 - list.length % 7) % 7;

	let dateList = [];
	let pointList = [];

	for (var i=0; i<Math.ceil((list.length + leaving) / 7); i++) {
	    dateList = [];
	    pointList = [];
	    for (var j=0; j<7; j++) {
		if (i * 7 + j < list.length)
		    dateList.push(list[i * 7 + j]);
		else
		    dateList.push(null);
	    }
	    mapList.push(dateList);

	    for (var j=0; j<7; j++) {
		if (i * 7 + j < list.length)
		    pointList.push(list[i * 7 + j]);
		else
		    pointList.push(null);
	    }
	    mapList.push(pointList);
	}

	const column = mapList.map((item, i) => (
		<tr key={i}>
			{
			    item.map((listItem, j) => (
				(i % 2 == 0)?
					<th key={i*7+j}>{(listItem == null)? "-" : Moment(listItem.completedExamDate).format('MM/DD')}</th>
					: <td key={i*7+j}>{(listItem == null)? "-" : Math.round(listItem.percentage)+"점"+"("+listItem.count+")"}</td>))
			}
		</tr>)
	)

	return column;
    }

    showOverallRating = () => {
	const { overallRating, resultEmpty } = this.state;
	if (resultEmpty) return;

	const average = this.getTotalSectionScore().average;
	return (
		<div className="box-each">
                <h2>Overall Rating 종합평가</h2>
                <div className="box-in">
                    <ul className="list-rating">
                    	{ overallRating.map(({ id, name, min, max }) => (
                    		<li key={id} className={(average >= min && average < max)? "selected" : ""}>
                    			<span></span>
                    			<strong>{name}</strong>
                    			<em>{(id == 0)? "50 미만" : min+"-"+max}</em>
                                </li>
                    	))}
                    </ul>
                </div>
            </div>
	);
    }

    popupConfirm = () => {
	this.setState({errorMessage: ""});
    }

    render() {
	const { visible , user, groupOption, resultEmpty, errorMessage, result, startDate, endDate } = this.state;
        return (
            visible ?
                <div className="popupWrapper report">
                    <div className="popup">
                        <div className="alertWrapper">

                            <dl className="alert">
                                <dt className="title">
                                    <span>{(new Date().getMonth() + 1) + '월 EVALUATION'}</span>
                                    <a className="btn-close" onClick={this.closePopup}/>
                                </dt>
                                <dd className="contents">

                                    <ul className="list-info">
                                        <li>Zeus</li>
                                        <li>{user.name}</li>
                                        <li>{user.grade}</li>
                                    </ul>

                                    <div className="wrap-grade">

                                        <div className="box-filter">
                                            <div className="box-calender">
                                                <div className="wrap-date">
                                                    <DatePicker
                                                        selected={this.state.startDate}
                                                        selectsStart
                                                        startDate={this.state.startDate}
                                                        endDate={this.state.endDate}
                                                        onChange={this.handleChangeStart}/>
                                                </div>
                                                <span className="txt-mid">~</span>
                                                <div className="wrap-date">
                                                    <DatePicker
                                                        selected={this.state.endDate}
                                                        selectsEnd
                                                        startDate={this.state.startDate}
                                                        endDate={this.state.endDate}
                                                        onChange={this.handleChangeEnd}/>
                                                </div>
                                                <a className="btn-mini icon search" onClick={() => this.searchReport(startDate, endDate, user.username)}></a>

                                            </div>
                                            <a className="btn-mini" onClick={this.showDailyBox}>직접 입력</a>
                                            {this.showDailyTestInputBox()}
                                            <a className="btn-mini navy" href="javascript:">성적표 프린트</a>
                                        </div>

                                        { !resultEmpty?
                                        <div className="box-filter">
                                		<a className={(groupOption.filterGraphEnable)? "btn-mini all" : "btn-mini dim"}
                                		onClick={()=> {this.onChangeSectionFilterValue("graph", -1)}}>{groupOption.name}</a>
                                		{this.showSectionFilterButton("graph")}
                                	</div> : null
                                        }

                                        {this.showSectionScore()}

                                        { !resultEmpty?
                                        <div className="box-filter">
                                		<a className={(groupOption.filterScoreByDateEnable)? "btn-mini all" : "btn-mini dim"}
                                		onClick={()=> {this.onChangeSectionFilterValue("scoreByDate", -1)}}>{groupOption.name}</a>
                                		{this.showSectionFilterButton("scoreByDate")}
                                	</div> : null
                                        }

                                        {this.showAverageByDate()}
                                        {this.showScoreByDate("vocabulary", "box-in type-test type-voca")}
                                        {this.showScoreByDate("listening", "box-in type-test type-listen")}
                                        {this.showScoreByDate("reading", "box-in type-test type-read")}
                                        {this.showScoreByDate("speaking", "box-in type-test type-speak")}
                                        {this.showScoreByDate("dailytest", "box-in type-test type-daily")}

                                        {/*
                                            <div className="box-each">
                                            <h2>BRAVO Test 낭독 점수</h2>

                                            <div className="box-in">
                                                <div className="list-percent">

                                                </div>
                                                <ul className="list-testInfo">
                                                    <li>
                                                        <span>Accuarcy 정확성</span>
                                                        <em>틀리게 읽었는가?-이해하며 읽었는가?</em>
                                                    </li>
                                                    <li>
                                                        <span>Fluency 유창성</span>
                                                        <em>속도 조절하며 읽었는가? 쉼표-마침표에 맞게 읽었는가?</em>
                                                    </li>
                                                    <li>
                                                        <span>Expression 표현성</span>
                                                        <em>말하듯이 자연스럽게 읽었는가?</em>
                                                    </li>
                                                    <li>
                                                        <span>Punctuality 성실성</span>
                                                        <em>BRAVO의 룰을 지켰는가?</em>
                                                    </li>
                                                </ul>
                                            </div>

                                        </div>*/}
                                        {this.showOverallRating()}
                                    </div>
                                </dd>

                                <dd className="box-footer">
                                    <span></span>
                                </dd>

                            </dl>
                        </div>
                    </div>
                    {<PopupAlert active={ errorMessage != "" } message={errorMessage} onConfirm={this.popupConfirm}/>}
                </div> : null
        );
    }
}


export default PopupReportCard;



// WEBPACK FOOTER //
// ./src/components/Containers/PopupReportCard/index.js